module.exports = __webpack_public_path__ + "assets/img/EXPOSE_API_PLUGIN.189bcd66.svg";